// Estilos centralizados para o Dashboard
import { makeStyles } from '@material-ui/core/styles';

export const useDashboardStyles = makeStyles((theme) => ({
  container: {
    transition: 'opacity 0.3s ease',
  },
  containerLoading: {
    cursor: 'wait',
    opacity: 0.7,
  },
  containerNormal: {
    cursor: 'default',
    opacity: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& > *': {
        marginBottom: theme.spacing(1),
      },
    },
  },
  title: {
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  buttonGroup: {
    marginLeft: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      alignSelf: 'flex-end',
    },
  },
  metricsGrid: {
    marginBottom: theme.spacing(2.5),
  },
  chartsGrid: {
    marginTop: theme.spacing(3),
  },
  errorContainer: {
    padding: theme.spacing(2.5),
    textAlign: 'center',
  },
  errorTitle: {
    marginBottom: theme.spacing(1),
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
}));

// Estilos para componentes específicos
export const chartStyles = {
  paper: {
    padding: '20px',
    height: '300px',
  },
  responsiveContainer: {
    width: '100%',
    height: '85%',
  },
};

// Cores para gráficos (mantendo consistência)
export const CHART_COLORS = {
  primary: '#8884d8',
  secondary: '#82ca9d',
  tertiary: '#ffc658',
  quaternary: '#ff8042',
  success: '#00C49F',
  warning: '#FFBB28',
  info: '#0088FE',
};

// Mapeamento de cores por tipo de gráfico
export const CHART_TYPE_COLORS = {
  dailySales: CHART_COLORS.primary,
  periods: CHART_COLORS.secondary,
  paymentMethods: CHART_COLORS.primary,
  mainMetrics: CHART_COLORS.tertiary,
  topServices: CHART_COLORS.primary,
  topProducts: CHART_COLORS.quaternary,
  topCustomers: CHART_COLORS.success,
};
